<template>
  <div class="outline">
    <div class="leftRow">
      <div class="body">
        <img src="@/assets/image/logo.png" class="middleImg" />
        <!-- 中间 -->
        <div style="margin:4.444vh 0px 0px 3.0208vw;height:9.259vh">
          <div style="float:left">
            <div class="english">GUIDE</div>
          </div>
          <div class="chinese">导游</div>
        </div>

        <!-- 底部 -->
        <div class="footerMenu" style="margin-left:0.9375vw">
          <div
            :class="classNameA"
            @mouseover="classNameA = 'colAHover'"
            @mouseout="classNameA = 'colA'"
            @click="openTypeLise(3)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">其</div>
            <div class="chaFont">他</div>
            <div class="chaFont">导</div>
            <div class="chaFont">游</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
          <div
            :class="classNameB"
            @mouseover="classNameB = 'colAHover'"
            @mouseout="classNameB = 'colA'"
            @click="openTypeLise(2)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">星</div>
            <div class="chaFont">级</div>
            <div class="chaFont">导</div>
            <div class="chaFont">游</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
          <div
            :class="classNameD"
            @mouseover="classNameD = 'colAHover'"
            @mouseout="classNameD = 'colA'"
            @click="openTypeLise(1)"
          >
            <div class="cha">︻</div>
            <div class="chaFont" style="margin-top:0.74074vh">中</div>
            <div class="chaFont">级</div>
            <div class="chaFont">导</div>
            <div class="chaFont">游</div>
            <div class="cha" style="margin-top:0.74074vh">︼</div>
          </div>
        </div>
      </div>
    </div>
   
  </div>
</template>

<script>
import  "@/css/switch.css"
import Banner from "../../components/common/banner";
export default {
  name: "OutLine",
  components: { Banner },
  data() {
    return {
      classNameA: "colA",
      classNameB: "colA",
      classNameC: "colA",
      classNameD: "colA"
    };
  },
  methods: {
    openTypeLise(type) {
      this.$store.commit("setChildMenu",9);
      this.$store.commit("setTabPage", type);
      this.$store.commit("setShowSwitchMenu", false);
      let name = "TabGuide";
      this.$emit("specialtyListFunction", name);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/guide/guideSwitch.vue